export default function() {}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-shape/src/noop.js
// module id = ../../../../d3-shape/src/noop.js
// module chunks = 4